import React from 'react';

const ProjectDetails = (props) => {
        console.log(props.project);
        const { details, mockup } = props.project;
        return (
                <div>
                        <h6>{details}</h6>
                        <div className="mt-4">
                                <h6>basically there are some feature about management. In below I will explain it by some point--</h6>
                                {
                                        props?.project?.details_li?.map(li => <li className="ms-5">{li?.li}</li>)
                                }
                        </div>
                        <div className="row mt-5 mb-5">
                                <div className="col-lg-10 col-md-10 col-12 mx-auto brand-border">
                                        <img src={mockup} className="img-fluid rounded-2" alt="" />
                                </div>
                        </div>
                        <div className="mt-4">
                                <h6>For complete this website I had to follow some technologies.I am going to share it in the below by some point--</h6>
                                {
                                        props?.project?.tec_li?.map(li => <li className="ms-5">{li?.li}</li>)
                                }
                        </div>
                        <div className="mt-5">
                                <h3 className="text-center brand-color fw-bold">Thank You So Much for visit here!</h3>
                        </div>
                </div>
        );
};

export default ProjectDetails;